import { useEffect, useRef } from 'react'
import { BrowserRouter, Route, Routes, useLocation, useNavigate, useParams } from 'react-router'
import { Provider } from 'mobx-react'
import { getEnv } from 'mobx-state-tree'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isBetween from 'dayjs/plugin/isBetween'
import relativeTime from 'dayjs/plugin/relativeTime'
import './index.css'
import 'toastr/build/toastr.css'
import 'tippy.js/themes/light.css'

import AppStore from './AppStore'
import Guide from './views/guide'
import { LoginDashboard } from './views'
import { RetailDashboard } from './views'
import { ScrollToTop } from './components'
import AppGateway from './AppGateway'
import ThemeWrapper from './themes/ThemeWrapper'
import AtmosLogin from './views/login/AtmosLogin'

// Add dayjs plugins needed across application
dayjs.extend(isSameOrBefore).extend(isSameOrAfter).extend(isBetween).extend(relativeTime)

function AppContent() {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()
  const storeRef = useRef()

  if (!storeRef.current) {
    storeRef.current = AppStore.create({}, {})
  }
  const store = storeRef.current

  useEffect(() => {
    const env = getEnv(store)
    env.navigate = navigate
    env.location = location
    env.match = { params }
  }, [navigate, location, params, store])

  const { isAuthenticated } = store.auth

  return (
    <Provider store={store}>
      <ThemeWrapper isAuth={isAuthenticated}>
        <ScrollToTop>
          <Routes>
            <Route path='/implement/guide/:caseId' element={<Guide />} />
            <Route path='/atmos/*' element={<LoginDashboard />} />
            <Route path='/atmos-login' element={<AtmosLogin />} />
            {/* old atmos login that still needs to be here */}
            <Route path='/retail/*' element={<RetailDashboard />} />
            <Route path='*' element={<AppGateway />} />
          </Routes>
        </ScrollToTop>
      </ThemeWrapper>
    </Provider>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  )
}

export default App
